<!--店铺管理-->
<template>
  <div class="app-container">
    <!--    查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div> -->
    <el-card class="operate-container" shadow="never">
      <div class="filter-container">
        <el-form :inline="true" :model="queryParam" label-width="113px">
          <el-form-item label="卡名称:">
            <el-input v-model="queryParam.name" placeholder="输入卡名称" style="width: 147px"></el-input>
          </el-form-item>
          <el-form-item label="消费类型:">
            <el-select v-model="queryParam.expType" placeholder="选择消费类型" style="width: 147px">
              <el-option v-for="item in optionsExpType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本:">
            <el-select v-model="queryParam.storeLessonCardTemplateId" placeholder="选择版本" style="width: 147px"
              @change="changeLessonIdX">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型:">
            <el-select v-model="queryParam.storeLessonId" placeholder="选择业务类型" style="width: 147px">
              <el-option v-for="item in storeLessonsList" :key="item.storeLessonId" :label="item.name"
                :value="item.storeLessonId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 30px">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
              @click="handleResetSearch()" style="margin-left: 30px">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="app-container-content">
      <!--    查询结果区域-->
      <div class="title-container" shadow="never" style="padding-top: 20px">
        <!-- <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div> -->
        <div></div>
        <div>
          <el-button type="primary" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="clickOPenModelBtns(1)">新增体验卡</el-button>
          <el-button type="primary" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="clickOPenModelBtns(2)">新增会员卡</el-button>
          <el-button type="primary" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="clickOPenModelBtns(3)">编辑</el-button>
          <el-button type="primary" class="operator-btn" icon="el-icon-circle-plus-outline"
            @click="clickOPenModelBtns(4)">主业务设置</el-button>
          <el-button type="primary" class="operator-btn" icon="el-icon-circle-plus-outline" style="margin-right: 23px"
            @click="clickOPenModelBtns(5)">多业务设置</el-button>
          <!-- <el-button
            type="primary"
            class="operator-btn"
            icon="el-icon-circle-plus-outline"
            @click="handleCreateOneShowDlg()"
            >添加VIP卡</el-button
          > -->
        </div>
      </div>
      <div class="table-container" style="margin-top: 20px">
        <el-table ref="tableData" style="width: 100%" :data="tableData" max-height="520" v-loading="listLoading" border
          :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }" @row-click="rowClick"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <!--<el-table-column-->
          <!--type="selection"-->
          <!--width="55">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
          <!-- <el-table-column prop="id" label="标识"></el-table-column> -->
          <el-table-column prop="id" label="卡ID"></el-table-column>
          <el-table-column prop="name" label="卡名称"></el-table-column>
          <el-table-column prop="storeLessonIdDes" label="版本"></el-table-column>
          <el-table-column prop="lessonName" label="业务类型"></el-table-column>
          <!-- <el-table-column prop="storeLessonIdDes" label="版本"></el-table-column> -->
          <el-table-column prop="useType" label="使用类型"></el-table-column>
          <el-table-column prop="validDays" label="有效期(天)">
            <template slot-scope="{row}">
              <div v-if="row.consumeType == 1">
               {{row.validTimesDays}}
              </div>
              <div v-else>{{row.validDays}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="consumeType" label="计费类型">
            <template slot-scope="scope">
              <div v-if="scope.row.consumeType == 1">时效卡</div>
              <div v-else>按次</div>
            </template>
          </el-table-column>
          <el-table-column prop="totalClassCount" label="正价课时"></el-table-column>
          <el-table-column prop="giveClassCount" label="赠送课时"></el-table-column>
          <el-table-column prop="valueMoney" label="价值(元)"></el-table-column>
          <el-table-column prop="" label="扣课比例"></el-table-column>
          <el-table-column prop="statuDes" label="状态"></el-table-column>
          <el-table-column prop="expType" label="消费类型"></el-table-column>
          <!--<el-table-column prop="createAdminName" label="生成卡的账号" ></el-table-column>-->
          <!--<el-table-column prop="points" label="开卡积分" ></el-table-column>-->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.statu == 0">
                <el-button @click="handleForbitOne(scope.row)" type="danger" size="small" plain>禁用</el-button>
              </div>
              <div v-if="scope.row.statu == 1">
                <el-button @click="handleUseOne(scope.row)" type="primary" size="small" plain>启用</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    禁用-->
    <el-dialog title="禁用" :visible.sync="visibleDlgForbit" width="50%" center>
      <div class="edit-area">
        <el-row style="margin-top: 10px">
          <el-col :span="10">
            <div style="margin-top: 10px; margin-left: 30px">
              卡名称 :
            </div>
          </el-col>
          <el-col :span="14">
            <div style="margin-top: 10px; margin-left: 30px">
              {{ forbitParam.name }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer-1">
        <el-button @click="visibleDlgForbit = false">取消</el-button>
        <el-button type="primary" @click="handleForbit">禁用</el-button>
      </div>
    </el-dialog>
    <!--    添加VIP卡-->
    <el-dialog title="添加体验卡" :visible.sync="visibleDlgAdd" width="50%" top="8vh" center>
      <NewStoreLessonCardInfo ref="AddNewVIPCard" :is-exp="0" :key="timeRefresh" @onBtnCreate="onBtnCreate">
      </NewStoreLessonCardInfo>
      <div slot="footer" class="dialog-footer-1">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne('AddNewVIPCard')">保存</el-button>
      </div>
    </el-dialog>
    <!--    添加体验卡-->
    <el-dialog title="添加体验卡" :visible.sync="visibleDlgAddExpCard" width="50%" top="8vh" center>
      <NewStoreLessonCardInfo ref="AddNewExpCard" :store-lessons="storeLessons" :is-exp="1" :key="timeRefresh">
      </NewStoreLessonCardInfo>
      <div slot="footer" class="dialog-footer-1">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne('AddNewExpCard')">保存</el-button>
      </div>
    </el-dialog>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>

    <template v-if="visibleAddExpCardVT">
      <el-dialog :title="visibleType == 1 ? '新增体验卡' : '编辑体验卡'" :visible.sync="visibleAddExpCardVT" width="550px" top="8vh"
        center>
        <expCardVT :childInfo="selectRow" :store-lessons="storeLessons" @onBtnCancel="visibleAddExpCardVT = false"
          @onBtnCreate="onBtnCreateVA" />
      </el-dialog>
    </template>
    <template v-if="visibleAddVIPCardVT">
      <el-dialog :title="visibleType == 1 ? '新增会员卡' : '编辑会员卡'" :visible.sync="visibleAddVIPCardVT" width="1000px"
        top="8vh" center>
        <vipCardVT :childInfo="selectRow" :store-lessons="storeLessons" @onBtnCancel="visibleAddVIPCardVT = false"
          @onBtnCreate="onBtnCreateVB" />
      </el-dialog>
    </template>
    <template v-if="visibleAddHostCardVT">
      <el-dialog title="主业务设置" :visible.sync="visibleAddHostCardVT" width="550px" top="8vh" center>
        <hostCardVT :store-lessons="storeLessons" @onBtnCancel="visibleAddHostCardVT = false"
          @onBtnCreate="onBtnCreateVC" />
      </el-dialog>
    </template>
    <template v-if="visibleAddMuchCardVT">
      <el-dialog title="多业务设置" :visible.sync="visibleAddMuchCardVT" width="900px" top="8vh" center>
        <muchCardVT :store-lessons="storeLessons" @onBtnCancel="visibleAddMuchCardVT = false"
          @onBtnCreate="onBtnCreateVD" />
      </el-dialog>
    </template>
  </div>
</template>

<style scoped lang="scss">
/deep/ .el-table th.el-table__cell>.cell {
  /* width: 90%; */
  height: 100%;
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.app-container {
  .operate-container {
    border: none;
  }

  /deep/ .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }

  .table-container {
    border: none;
    border-radius: 0px;

    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }
}
</style>

<script>
import { DateDiff } from '@/utils/date';
import {
  fechListLessonExpCard,
  fechListLessonVipCard,
  forbitLessonCard,
  newLessonExpCard,
  newLessonVipCard,
  useLessonCard,
} from "../../api/StoreLessonCard";
import { qlLessonTemplate } from "@/api/StoreLesson";
import globaldata from "../../utils/globaldata";
import commonUtils from "../../utils/commonUtils";
import messageUtils from "../../utils/messageUtils";
import WorkerWord from "../../components/WorkerWord/WorkerWord";
import NewStoreLessonCardInfo from "./components/NewStoreLessonCardInfo";
import expCardVT from "./components/expCardVT.vue";
import vipCardVT from "./components/vipCardVT.vue";
import hostCardVT from "./components/hostCardVT.vue";
import muchCardVT from "./components/muchCardVT.vue";
import enumsUtil, {
  ECardExpType,
  ECardUseType,
  getEnumDesByV,
} from "../../utils/enumsUtil";

export default {
  components: {
    NewStoreLessonCardInfo,
    WorkerWord,
    expCardVT,
    vipCardVT,
    hostCardVT,
    muchCardVT,
  },
  data() {
    return {
      storeLessonsList: [],
      listLoading: true,
      visibleDlgAdd: false,
      visibleDlgAddExpCard: false,
      visibleDlgForbit: false,
      timeRefresh: "",
      isExp: -1,
gfds:'',
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
      queryParam: {
        name: "",
        expType: 0,
        storeLessonCardTemplateId: '',
        storeLessonId: '',
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      optionsExpType: [
        {
          value: 0,
          label: "VIP卡",
        },
        {
          value: 1,
          label: "体验卡",
        },
      ],

      cooperationDate: "", //合作时间
      multipleSelection: [], //选择的表单
      //表单结果
      tableData: [],

      forbitParam: {
        id: "",
        name: "",
      },

      //编辑店铺信息
      editStoreInfo: {},
      //店铺可以使用的课程
      storeLessons: "",

      createParam: {},

      rules: {
        name: [{ required: true, message: "请输入卡名称", trigger: "blur" }],
        descripe: [
          { required: true, message: "请输入卡描述", trigger: "blur" },
        ],
        storeLessonCardTemplateId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        optionsValue: [
          { required: true, message: "请选择计费类型", trigger: "blur" },
        ],
        totalClassCount: [
          { required: true, message: "请输入正价课时", trigger: "blur" },
        ],
        valueMoney: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        optionsUseValue: [
          { required: true, message: "请选择启用状态", trigger: "blur" },
        ],
        optionsLessonValue: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
      },

      selectRow: null,
      visibleAddExpCardVT: false,
      visibleAddVIPCardVT: false,
      visibleAddHostCardVT: false,
      visibleAddMuchCardVT: false,
      visibleType: 1, //1添加 2编辑
      multipleSelection: []
    };
  },
  created() {
    globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
    this.initParam();
  },
  mounted() { },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection, '===============')
    },
    changeLessonIdX(e) {
      // console.log(e,'===============')console.log(e,'===============')
      // return
      this.queryParam.storeLessonId = ''
      qlLessonTemplate({
        lessonId: e,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    onBtnCreateVD() {
      messageUtils.successMsg(this, "创建成功");
      this.visibleAddMuchCardVT = false;
      this.flechList();
    },
    onBtnCreateVC() {
      messageUtils.successMsg(this, "创建成功");
      this.visibleAddHostCardVT = false;
      this.flechList();
    },
    onBtnCreateVB() {
      this.visibleAddVIPCardVT = false;
      this.flechList();
    },
    onBtnCreateVA() {
      messageUtils.successMsg(this, "创建成功");
      this.visibleAddExpCardVT = false;
      this.flechList();
    },
    rowClick(row, column, event) {
      this.selectRow = row;
    },
    clickOPenModelBtns(from) {
      let self = this;
      console.log("clickOPenModelBtns", from);
      console.log("selectRow", self.selectRow);
      switch (from) {
        case 1:
          // 新增体验卡
          self.visibleType = 1;
          this.selectRow = {}
          self.visibleAddExpCardVT = true;
          break;
        case 2:
          // 新增会员卡
          self.visibleType = 1;
          this.selectRow = {}
          self.visibleAddVIPCardVT = true;
          break;
        case 3:
          // 编辑
          // if (commonUtils.isObjectNull(self.selectRow)) {
          //   messageUtils.errorMsg(self, "请先选择一条信息");
          //   return false;
          // }
          if (self.multipleSelection.length == 0 || self.multipleSelection.length > 1) {
            messageUtils.errorMsg(self, "请先选择一条信息");
            return
          }
          self.selectRow = self.multipleSelection[0]
          console.log(self.selectRow,'self.selectRow')
          self.visibleType = 2;
          if (self.selectRow.experience == 0) {
            // VIP卡
            self.visibleAddVIPCardVT = true
          } else {
            self.visibleAddExpCardVT = true;
          }

          // 判断体验卡/会员卡,打开对应弹窗
          break;
        case 4:
          // 主业务设置
          self.visibleAddHostCardVT = true;
          break;
        case 5:
          // 多业务设置
          self.visibleAddMuchCardVT = true;
          break;
      }
    },
    initParam() {
      this.createParam = {
        name: "",
        descripe: "",
        storeLessonCardTemplateId: "",
        storeFrontId: "",
        storeLessonId: "",
        validDays: "",
        totalClassCount: 0,
        giveClassCount: 0,
        valueMoney: "",
        createAdminId: "",
        consumeType: "",
        statu: "",
        storeLessonIdDes: "",
        createAdminName: "",
        statuDes: "",
        consumeDes: "",

        options: [
          {
            value: "0",
            label: "按次",
          },
        ],
        optionsValue: "",
        optionsLesson: [
          {
            id: "0",
            name: "基础游",
          },
        ],
        optionsLessonValue: "",
        optionsUse: [
          {
            value: "0",
            label: "启用",
          },
          {
            value: "1",
            label: "禁用",
          },
        ],
        optionsUseValue: "",
        points: 0,
      };
    },
    getStoreLessonTemplate(data) {
      this.storeLessons = data;
      this.flechList();
    },
    handleResetSearch() {
      this.queryParam = {
        name: "",
        expType: 0,
        storeLessonCardTemplateId: '',
        storeLessonId: '',
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
        this.flechList();
    },
    flechList() {
      this.listLoading = true;
      let param = {
        storeLessonCardTemplateId: this.queryParam.storeLessonCardTemplateId,
        storeLessonId: this.queryParam.storeLessonId,
        expType: this.queryParam.expType,
        cardName: this.queryParam.name,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
      };
      if (this.queryParam.expType == 0) {
        fechListLessonVipCard(param).then((response) => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          this.queryParam.totalPage = data.total;
          this.refreshData(data.list);
        });
      } else if (this.queryParam.expType == 1) {
        fechListLessonExpCard(param).then((response) => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            return;
          }
          console.log("fechListLessonExpCard", data);
          this.queryParam.totalPage = data.total;
          this.refreshData(data.list);
        });
      }
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }

      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {
        let statuDes = "启用";
        let consumeDes = "按次";
        if (list[i].statu == 1) {
          statuDes = "禁用";
        }
        if (list[i].consumeType == 0) {
          consumeDes = "按次";
        }
        let expType = ECardExpType(list[i].experience);


        // let storeLessonIdDes = this.getstoreLesson(
        //   list[i].storeLessonCardTemplateId
        // ).type;

        let data = {
          number: i + 1,
          id: list[i].id,
          name: list[i].name,
          descripe: list[i].descripe,
          storeLessonCardTemplateId: list[i].storeLessonCardTemplateId,
          storeLessonId: list[i].storeLessonId,
          validDays: list[i].validDays,
          validTimesDays:list[i].consumeType == 1 && list[i].startTime && list[i].endTime ?  DateDiff(list[i].startTime,list[i].endTime) + 1 : null,
          totalClassCount: list[i].totalClassCount,
          giveClassCount: list[i].giveClassCount,
          valueMoney: list[i].valueMoney,
          createTime: list[i].createTime,
          createAdminId: list[i].createAdminId,
          consumeType: list[i].consumeType,
          statu: list[i].statu,
          points: list[i].points,
          lessonName: list[i].lessonName,
          experience: list[i].experience,
          validTimes:list[i].startTime ? [list[i].startTime,list[i].endTime] : [],
          remark: list[i].remark,
          frequency:list[i].frequency,
          // storeLessonIdDes: storeLessonIdDes,
          storeLessonIdDes:list[i].storeLessonCardTemplateId == 1 ? 'B' : 'A',
          statuDes: statuDes,
          consumeDes: consumeDes,
          expType: expType,
          useType: getEnumDesByV(list[i].useType, ECardUseType()),
        };
        tableDataList.push(data);
      }
      this.tableData = tableDataList;
    },
    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },

    handleCurrentChange(val) {
      this.queryParam.pageSize = 10
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = val;
      this.flechList();
    },

    //禁用
    handleForbitOne(row) {
      let tData = {
        cardId: row.id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
      };
      this.doRefreshWord(true, 2, tData);
    },
    handleForbit(param) {
      forbitLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
        this.closeWordDlg();
      });
    },

    handleUseOne(row) {
      let tData = {
        cardId: row.id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
      };
      this.doRefreshWord(true, 3, tData);
    },
    handleUse(param) {
      useLessonCard(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.flechList();
        this.closeWordDlg();
      });
    },

    handleCreateOneShowDlg() {
      this.initParam();
      this.visibleDlgAdd = true;
    },
    handleCreateExpCardShowDlg() {
      this.timeRefresh = new Date().getTime();
      this.visibleDlgAddExpCard = true;
    },
    getstoreLesson(lessonTemplateId) {
      console.log(this.storeLessons,'this.storeLessons')
      for (let i = 0; i < this.storeLessons.length; ++i) {
        if (this.storeLessons[i].id == lessonTemplateId) {
          return this.storeLessons[i];
        }
      }
    },
    //添加

    showWordDlgCreate() {
      let storeLessonId = this.getstoreLesson(
        this.createParam.optionsLessonValue
      ).storeLessonId;
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        name: this.createParam.name,
        descripe: this.createParam.descripe,
        storeLessonCardTemplateId: this.createParam.optionsLessonValue,
        storeLessonId: storeLessonId,
        validDays: this.createParam.validDays,
        totalClassCount: this.createParam.totalClassCount,
        giveClassCount: this.createParam.giveClassCount,
        valueMoney: this.createParam.valueMoney,
        createAdminId: globaldata.getAdminStore().id,
        consumeType: this.createParam.optionsValue,
        statu: this.createParam.optionsUseValue,
        points: this.createParam.points,
        useType: this.createParam.useType,
        cardSubTypeId: this.createParam.cardSubTypeId,
        adminWord: "",
      };
      this.tData = param;
      this.doRefreshWord(true, 1);
    },

    doCareateOne(param) {
      if (param.experience == 1) {
        newLessonExpCard(param).then((response) => {
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            messageUtils.errorMsg(this, "创建失败");
            return;
          }
          this.onCreateSuccess(data);
        });
      } else if (param.experience == 0) {
        newLessonVipCard(param).then((response) => {
          let data = response.data;
          if (commonUtils.isObjectNull(data)) {
            messageUtils.errorMsg(this, "创建失败");
            return;
          }
          this.onCreateSuccess(data);
        });
      }
    },
    onCreateSuccess(data) {
      messageUtils.successMsg(this, "创建成功");
      this.visibleDlgAdd = false;
      this.visibleDlgAddExpCard = false;
      this.closeWordDlg();
      this.flechList();
    },
    createExpCard() {
      // console.log('11111111111111')
      messageUtils.successMsg(this, "创建成功");
      this.visibleDlgAddExpCard = false
      this.flechList();
    },
    onBtnCreate() {
      console.log('11111111111111')
      messageUtils.successMsg(this, "创建成功");
      this.visibleDlgAdd = false
      this.flechList();
    },
    handleCreateOne(ref) {
      this.$refs[ref].getCardInfo(this.onGetCardInfo);
    },

    onGetCardInfo(info) {
      if (commonUtils.isObjectNull(info) || info == false) {
        return;
      }
      this.doRefreshWord(true, 1, info);
    },

    handleWord(wordType, tData) {
      //添加
      if (wordType == 1) {
        this.doCareateOne(tData);
      } else if (wordType == 2) {
        //禁用
        this.handleForbit(tData);
      } else if (wordType == 3) {
        //启用
        this.handleUse(tData);
      }
    },
    doRefreshWord(show, wordType, tData) {
      this.wordType = wordType;
      this.tData = tData;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },
    closeWordDlg() {
      this.wordType = 0;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/store-lesson-card/index.vue